export function deliveryDates(now = new Date(), inStock = true) {
  const parts = Object.fromEntries(new Intl.DateTimeFormat('en-GB', { timeZone:'Europe/Madrid',year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',hourCycle:'h23' }).formatToParts(now).map(p=>[p.type,p.value]));
  const today = new Date(Date.UTC(Number(parts.year),Number(parts.month)-1,Number(parts.day),12));
  const workday = d => d.getUTCDay()!==0 && d.getUTCDay()!==6;
  const add = (d,n) => { const r=new Date(d);while(n>0){r.setUTCDate(r.getUTCDate()+1);if(workday(r))n--;}return r; };
  let dispatch = new Date(today);
  if(!workday(dispatch)||Number(parts.hour)>=14){do{dispatch.setUTCDate(dispatch.getUTCDate()+1);}while(!workday(dispatch));}
  return { today, dispatch:inStock?dispatch:add(dispatch,1), earliest:add(dispatch,inStock?1:2),latest:add(dispatch,inStock?2:3) };
}
class JerezDelivery extends HTMLElement {
  static get observedAttributes(){ return ['data-in-stock','data-available']; }
  connectedCallback(){this.renderDates();this.observer=new MutationObserver(()=>this.renderDates());this.observer.observe(this,{childList:true,subtree:true});}
  disconnectedCallback(){this.observer?.disconnect();}
  attributeChangedCallback(){if(this.isConnected)this.renderDates();}
  renderDates(){
    const d=deliveryDates(new Date(),this.dataset.inStock==='true');
    const format=x=>new Intl.DateTimeFormat('es-ES',{timeZone:'UTC',day:'numeric',month:'short'}).format(x);
    const set=(selector,value)=>{const target=this.querySelector(selector);if(target&&target.textContent!==value)target.textContent=value;};
    set('[data-order-date]',format(d.today));
    set('[data-dispatch-date]',this.dataset.available==='true'?format(d.dispatch):'Consultar disponibilidad');
    set('[data-delivery-date]',this.dataset.available==='true'?`${format(d.earliest)} – ${format(d.latest)}`:'Antes de comprar');
  }
}
if(!customElements.get('jerez-delivery'))customElements.define('jerez-delivery',JerezDelivery);
